import React from "react";
import useStyles from "../../styles";
import { useState, useEffect } from "react";
import { decryptData } from "../../crypto";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Button,
  FormControl,
  FormLabel,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
function LearnerDetails(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const [center, setCenter] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");

  const [cources, setCources] = useState([]);
  const [selectedCource, setSelectedCource] = useState("");

  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");

  const fetchCenter = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/filter/all`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      if (response.status === 200) {
        setCenter(response.data.centers);
      } else {
        console.error("Failed to fetch Branch data");
      }
    } catch (error) {
      console.error("Error fetching Branch data:", error);
    }
  };

  useEffect(() => {
    fetchCenter();
  }, []);

  const handleCenterChange = (event, newValue) => {
    setSelectedCenter(newValue ? newValue.id : event?.target?.value || "");
  };

  const fetchCources = async (selectedCenter) => {
    if (!selectedCenter) return;
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centerid/${selectedCenter}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      if (response.status === 200) {
        setCources(response.data.center.courses);
      } else {
        console.error("Failed to fetch batches data");
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    if (selectedCenter) {
      fetchCources(selectedCenter);
    }
  }, [selectedCenter]);

  const handleCourceChange = (event, newValue) => {
    setSelectedCource(newValue ? newValue.id : event?.target?.value || "");
  };

  const fetchBatches = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      // Ensure selectedCourses is not empty before making the request
      if (selectedCenter && selectedCource) {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centers/course`,
          {
            center: {
              centerId: selectedCenter,
              courseId: selectedCource,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status === 200) {
          setBatches(response.data.center.batches);
        } else {
          console.error("Failed to fetch batches data:", response);
        }
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    fetchBatches();
  }, [selectedCenter, selectedCource]);

  const handleBatchChange = (event, newValue) => {
    setSelectedBatch(newValue ? newValue.id : event?.target?.value || "");
  };

  let searchLearner = () => {
    navigate(
      `/admin/assignlearner/${selectedCource}/${selectedBatch}/${selectedCenter}`
    );
  };

  return (
    <>
      <div
        className={` ${classes.w100} ${classes.bgblue} ${classes.inputdropdowniconcolor}  ${classes.alignitemscenter}   ${classes.mt1}  ${classes.p1}   ${classes.borderradius6px}   ${classes.inputpadding} ${classes.inputborderwhite}  ${classes.inputplaceholdercolor}   ${classes.dflex}`}
      >
        <Typography variant="h6" className={`${classes.textcolorwhite} `}>
          Fetch Learners
        </Typography>

        <div
          className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24}`}
        >
          <FormLabel
            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
          ></FormLabel>
          {/* <Select
            labelId="batch-label"
            id="batch"
            value={selectedCenter}
            onChange={handleCenterChange}
            displayEmpty
            className={classes.selectEmpty}
            MenuProps={menuProps}
            variant="outlined"
          >
            <MenuItem disabled value="">
              <em className={classes.defaultselect}>Select Branch</em>
            </MenuItem>
            {center &&
              center.map((st) => (
                <MenuItem key={st.id} value={st.id}>
                {st?.center_code} - {st?.center_name}
                </MenuItem>
              ))}
          </Select> */}

          <Autocomplete
            id="branch-autocomplete"
            options={center || []}
            getOptionLabel={(option) =>
              option?.center_code
                ? `${option?.center_code} - ${option?.center_name}`
                : option?.center_name || ""
            }
            getOptionSelected={(option, value) => option?.id === value?.id}
            value={center?.find((st) => st.id === selectedCenter) || null}
            onChange={handleCenterChange}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Branch"
                variant="outlined"
              />
            )}
          />
        </div>

        <div
          className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24}`}
        >
          <FormLabel
            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
          ></FormLabel>
          {/* <Select
            labelId="category-label"
            id="state"
            value={selectedCource}
            onChange={handleCourceChange}
            displayEmpty
            // className={classes.selectEmpty}
            MenuProps={menuProps}
            variant="outlined"
          >
            <MenuItem disabled value="">
              <em className={classes.defaultselect}>Select Course</em>
            </MenuItem>
            {cources?.map((data, index) => {
              return (
                <MenuItem value={data.id} key={index}>
                  {data.course_name}
                </MenuItem>
              );
            })}
          </Select> */}

          <Autocomplete
            id="course-autocomplete"
            options={cources || []}
            getOptionLabel={(option) => option?.course_name || ""}
            getOptionSelected={(option, value) => option?.id === value?.id}
            value={cources?.find((data) => data.id === selectedCource) || null}
            onChange={handleCourceChange}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Course"
                variant="outlined"
              />
            )}
          />
        </div>

        <div
          className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24}`}
        >
          <FormLabel
            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
          ></FormLabel>
          {/* <Select
            labelId="batch-label"
            id="batch"
            value={selectedBatch}
            onChange={handleBatchChange}
            displayEmpty
            className={classes.selectEmpty}
            MenuProps={menuProps}
            variant="outlined"
          >
            <MenuItem disabled value="">
              <em className={classes.defaultselect}>Select Batch</em>
            </MenuItem>
            {batches?.map((data, index) => {
              return (
                <MenuItem key={index} value={data.id}>
                  {data.batch_name}
                </MenuItem>
              );
            })}
          </Select> */}

          <Autocomplete
            id="batch-autocomplete"
            options={batches || []}
            getOptionLabel={(option) => option?.batch_name || ""}
            getOptionSelected={(option, value) => option?.id === value?.id}
            value={batches?.find((data) => data.id === selectedBatch) || null}
            onChange={handleBatchChange}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Batch"
                variant="outlined"
              />
            )}
          />
        </div>

        <Button
          variant="contained"
          color="primary"
          className={`${classes.whitebtn}  ${classes.mx0_5}`}
          onClick={searchLearner}
        >
          Search Learners
        </Button>
      </div>
    </>
  );
}
export default LearnerDetails;
